import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {GenericsService} from '../../services/generics.service';
import {TokenStorageService} from '../../services/token-storage.service';
import {ActivityService} from 'ng-metro4';
import {ActivatedRoute} from '@angular/router';
import {ModelDataFactory} from './model-factory';
import {CommunicationService} from '../../services/communication.service';
import {TranslateService} from '@ngx-translate/core';
import {HabilitationModel} from "../../models/column-model";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-bdc-reglements-factory',
  templateUrl: './bdc-reglements-factory.component.html',
  styleUrls: ['./bdc-reglements-factory.component.css']
})
export class BdcReglementsFactoryComponent implements OnInit {
  @Input() configComponent: ModelDataFactory;
  @Input() token: string;
  @Input() dataMapper: any[];
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();
  @Output() onReject: EventEmitter<any> = new EventEmitter();
  @Output() objectSelected: EventEmitter<any> = new EventEmitter();
  @Output() onShowDetails: EventEmitter<any> = new EventEmitter();
  @Output() onEmitFilterSide: EventEmitter<any> = new EventEmitter();
  normalizedData: any[] = [];
  currentUser: number;
  currentUrl: any;
  currentObject: any;
  page = 0;
  size = 20;
  sort = 'DESC';
  orderBy = 'id';
  urlListing = '';
  public totalItems: number;
   attributeMapping: { [key: string]: string };
  dataApi: any[] = [];

  constructor(
    public genericsService: GenericsService,
    private tokenStorageService: TokenStorageService,
    private activityService: ActivityService,
    private route: ActivatedRoute,
    private communicationService: CommunicationService,
    private authService: AuthService,
    public translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.communicationService.dataSubjectToRefreshTable$.subscribe((conf: any) => {
      console.log(conf);
      if (conf){
        this.urlListing = conf.urlListing;
        this.token = conf.token;
        this.fetchData(this.token);
      }else {
        this.fetchData('');
      }

    });
    console.log(this.configComponent);
    this.attributeMapping = this.configComponent.attributeMapping;
    // this.tableHeaders = this.configComponent.tableHeaders;
    this.urlListing = this.configComponent.urlListing;
    this.currentUrl = this.route?.snapshot?.params;

    this.fetchData(this.token);
  }
  currentCol(header: any): string {
    const item = header.field.split('.');
    return item[item.length - 1];
  }

  normalizeData(data: any[]): void {
    this.normalizedData = data.map(item => {
      const normalized: any = {};
      for (const key in this.attributeMapping) {
        if (this.attributeMapping.hasOwnProperty(key)) { // SE RASSURER QUE SEUL LES PROPRIETES DIRECT DE L'OBJET SOIT PRIS EN COMPTE
          normalized[key] = item[this.attributeMapping[key]];
        }
      }
      Object.keys(this.attributeMapping).forEach(key => {
        normalized[key] = item[this.attributeMapping[key]];
      });
      return normalized;
    });
  }

  fetchData(keyword: string): void {
    const message = this.tokenStorageService.getLangue() === 'EN' ? 'Loading ...' : 'Chargement ...';
    const activity = this.activityService.open({
      style: 'color',
      text: `<div class="mt-2 display1 fg-darkBlue">${message}</div>`,
      type: 'cycle',
      overlayColor: '#a7a0a0',
    });
    this.genericsService.getResource(`${this.urlListing}keyword=${keyword}&page=${this.page}&size=${this.size}&sort=${this.sort}&orderBy=${this.orderBy}`).then((result: any) => {
      console.log(result);
      this.currentObject = null;
      if (result.success) {
        // this.normalizeData(result.data ? result.data : []);
        this.dataApi = result.data.content ? result.data.content : [];
        this.totalItems = result.data.totalElements;
      }
    }).catch((error) => {
      console.error('Error fetching data:', error);
    }).finally(() => {
      this.activityService.close(activity);
    });
  }

  getFieldValue(row: any, field: string): any {
    return field.split('.').reduce((obj, key) => (obj ? obj[key] : null), row);
  }


  getItemHeaderToSort(header: any): void {
    this.orderBy = this.currentCol(header);
  }
  onSelect(reglement: any, habilitation: string): void {
    if (this.authService.isVisible(habilitation)) {
      this.currentObject = reglement;
      this.currentUser = reglement.id;
      this.objectSelected.emit(reglement);
    }
  }

  onChangePage(event): void {
    this.page = event - 1;
    this.fetchData('');
  }
}
